// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"TabelaEKompanive_containerDashboardP__UH-L7","mobileResponsive":"TabelaEKompanive_mobileResponsive__dz3wB"};